import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { useFetchCartones } from "../../hooks/useGetCartones";
import { useFetchSections } from "../../hooks/useGetSections";
import { Loading } from "../sharedComponents/Loading";
import { CartonCard } from "./panelCartones/CartonCard";
import { AddCarton } from "./panelCartones/AddCarton";
import { EditCarton } from "./panelCartones/EditCarton";
import { DeleteCarton } from "./panelCartones/DeleteCarton";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const CartonesPanel = ({ token, date, idDocument }) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedCarton, setSelectedCarton] = useState(null);
  const [selectedCartonId, setSelectedCartonId] = useState(null);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [selectedIdSection, setSelectedIdSection] = useState("");
  const { sections, loadingSection } = useFetchSections(token, idDocument);

  useEffect(() => {
    if (sections.length > 0 && !selectedIdSection) {
      setSelectedIdSection(sections[0]?.ID_SECCION);
    }
  }, [sections, selectedIdSection]);

  const { cartones, loadingCarton } = useFetchCartones(
    token,
    selectedDate,
    selectedIdSection,
    refresh,
    idDocument
  );

  const handleEditClick = (carton) => {
    setSelectedCarton(carton);
    setModalEdit(true);
  };

  const handleDeleteClick = (idCarton) => {
    setSelectedCartonId(idCarton);
    setModalDelete(true);
  };
  
  const handleDateChange = (event) => setSelectedDate(event.target.value);

  const renderItemsWithAddButton = () => {
    let content = [];
    let row = [];
  
    row.push(
      <Grid item xs={6} sm={4} md={3} key="add-button">
        <Item sx={{ display: 'flex', justifyContent: 'center' }}>
          <IconButton aria-label="add" color="primary" onClick={() => setModalAdd(true)}>
            <AddCircleOutlineIcon sx={{ fontSize: 40 }} />
          </IconButton>
        </Item>
      </Grid>
    );
  
    cartones.forEach((carton) => {
      row.push(
        <CartonCard 
          key={carton.id} 
          item={carton} 
          sections={sections}
          onEditClick={handleEditClick} 
          onDeleteClick={handleDeleteClick} 
        />
      );
    });
  
    content.push(
      <Grid container spacing={2} key="row">
        {row}
      </Grid>
    );
  
    return content;
  };

  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <TextField
          label="Fecha"
          type="date"
          variant="outlined"
          value={selectedDate}
          onChange={handleDateChange}
          InputLabelProps={{ shrink: true }}
          sx={{
            m: 1,
            minWidth: 80,
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
            },
          }}
        />
      </div>
      {loadingCarton || loadingSection ? (
        <Loading />
      ) : (
        <Box sx={{ flexGrow: 1, margin: 2 }}>
          {renderItemsWithAddButton()}
        </Box>
      )}
      <AddCarton
        token={token}
        open={modalAdd}
        close={() => setModalAdd(false)}
        selectedDate={selectedDate}
        selectedIdSection={selectedIdSection}
        sections={sections}
        idDocument={idDocument}
        refresh={() => setRefresh(!refresh)}
      />
      <EditCarton
        token={token}
        open={modalEdit}
        close={() => setModalEdit(false)}
        carton={selectedCarton}
        selectedDate={selectedDate}
        selectedIdSection={selectedIdSection}
        sections={sections}
        refresh={() => setRefresh(!refresh)}
      />
      <DeleteCarton
        token={token}
        open={modalDelete}
        close={() => setModalDelete(false)}
        idCarton={selectedCartonId}
        refresh={() => setRefresh(!refresh)}
      />
    </>
  );
};